<template>
<!-- 收款设置 -->
<div class="main_container skszWrap">
  <el-row :gutter="20">
    <el-col :span="12">
      <p class="modtTitle">重要说明</p>
      <ul class="zysmUl">
        <li>1.本页面申请资料主要用于开通微信收款，收款功能由微信支付提供服务。</li>
        <li>2.本页面提交的资料要较多请先准备好所有资料文件后，再进行填写；</li>
        <li>3.申请过成中涉及到多次验证；请务必填写可配合验证人员信息。</li>
        <!-- <li>4.提交申请后，资料将上传到微信支付平台，将无法撤销更改。</li> -->
      </ul>
    </el-col>
    <el-col :span="12">
      <p class="modtTitle"><span class="dpmcRight" v-show="shopName">企业名称：{{shopName}} </span>开通微信收款状态</p>
      <dl class="ktwxskzt">
        <dd>
          <p>当前状态：<span class="dqzt">{{currentState}}</span></p>
          <p>阶段描述：<span>{{describe}}</span></p>
          <p v-show="applymentState == 'ACCOUNT_NEED_VERIFY'">打款验证：<el-button size="mini" type="danger" @click="seePaymentInfo()">查看打款信息</el-button></p>
        </dd>
        <dt>
          <!-- <img src="../../assets/img/gongzhong.jpg" style="width:150px;height:150px;"> -->
          <img :src="signUrl" style="width:150px;height:150px;" v-show="applymentState == 'NEED_SIGN'">
          <img :src="legalUrl" style="width:150px;height:150px;" v-show="applymentState == 'ACCOUNT_NEED_VERIFY'">
        </dt>
      </dl>
    </el-col>
  </el-row>

  <p class="modtTitle">基本信息</p>
  <el-row :gutter="20">
    <el-col :span="12">
      <div class="elGroup">
        <el-button class="btnGroup">主体类型 :</el-button>
        <el-radio-group v-model="ztlx" :disabled="!isEdit">
          <el-radio :label="2">企业</el-radio>
          <el-radio :label="4">个体工商户</el-radio>
        </el-radio-group>
      </div>
      <div class="yyzzDiv">
        <el-button class="dropDown">营业执照 :</el-button>
        <el-image :src="yyzzLong" v-if="yyzzLong" class="yyzzAvatarImg" @click="handleClickItem" :preview-src-list="[yyzzLong]"/>
        <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 1)">
          <i class="el-icon-plus yyzzUploader"></i>
        </el-upload>
        <img src="../../assets/img/aicon36.png" class="yyzzDel" @click.stop="delIDcard(1)" v-show="isEdit && yyzzLong"/>
        <p class="yyzzSM"> 营业执照支持jpg、png格式、不超过2MB。 </p>
      </div>
      <div class="yyzzRight">
        <el-input v-model="qymc" placeholder="请输入企业名称" maxlength="30"
         class="singleRow whiteDis" style="width:83%" :disabled="!isEdit">
          <template slot="prepend">企业名称 :</template>
        </el-input>
        <el-input v-model="qyfr" placeholder="请输入企业法人" maxlength="21"
         class="singleRow whiteDis" style="width:83%" :disabled="!isEdit">
          <template slot="prepend">企业法人 :</template>
        </el-input>
        <el-input v-model="xydm" placeholder="请输入信用代码" maxlength="21"
         class="singleRow whiteDis" style="width:83%" :disabled="!isEdit">
          <template slot="prepend">信用代码 :</template>
        </el-input>
        <div style="margin-bottom: 20px;">
          <el-button class="dropDown">有效期限 :</el-button>
          <el-date-picker type="date" v-model="kssj" :editable="false" value-format="yyyy-MM-dd"
          placeholder="开始日期" style="width:25%;cursor:pointer;" :disabled="!isEdit"/> 至
          <el-date-picker type="date" v-model="jssj" :editable="false" value-format="yyyy-MM-dd"
          placeholder="选择日期" style="width:25%;cursor:pointer;" :disabled="!isEdit || yxqxOne"/>
          <!-- <el-date-picker type="date" v-model="jssj" :editable="false" value-format="yyyy-MM-dd" :picker-options="pickerOptions"
          placeholder="选择日期" style="width:58%;cursor:pointer;" :disabled="yxqxOne"/> -->
          <el-checkbox v-model="yxqxOne" style="margin-left: 10px;" :disabled="!isEdit">长期有效</el-checkbox>
        </div>
      </div>
    </el-col>
    <el-col :span="12">
      <el-input v-model="withdrawerName" placeholder="例如：大卫地板  （ 最多可输入21个字）" maxlength="21"
       class="singleRow whiteDis" :disabled="!isEdit">
        <template slot="prepend">商 户 简 称 :</template>
      </el-input>
      <div class="rxgh">
        <div class="rxghDiv">
          <el-image :src="rxLong" v-if="rxLong" class="rxghAvatarImg" @click="handleClickItem" :preview-src-list="[rxLong]"/>
          <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 2)">
            <i class="el-icon-plus rxghUploader"></i>
          </el-upload>
          <img src="../../assets/img/aicon36.png" class="chahao" @click.stop="delIDcard(2)" v-show="isEdit && rxLong"/>
          <p class="rxghSM"> 法人或经营者身份证正面（人像） </p>
        </div>
        <div class="rxghDiv">
          <el-image :src="ghLong" v-if="ghLong" class="rxghAvatarImg" @click="handleClickItem" :preview-src-list="[ghLong]"/>
          <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 3)">
            <i class="el-icon-plus rxghUploader"></i>
          </el-upload>
          <img src="../../assets/img/aicon36.png" class="chahao" @click.stop="delIDcard(3)" v-show="isEdit && ghLong"/>
          <p class="rxghSM"> 法人或经营者身份证反面（国徽） </p>
        </div>
      </div>
      <el-input v-model="sfzxm" placeholder="请输入身份证姓名" maxlength="21"
       class="singleRow whiteDis" :disabled="!isEdit">
        <template slot="prepend">身份证姓名 :</template>
      </el-input>
      <el-input v-model="sfzhm" placeholder="请输入身份证号码" maxlength="21"
       class="singleRow whiteDis" :disabled="!isEdit">
        <template slot="prepend">身份证号码 :</template>
      </el-input>
      <el-input v-model="jzdz" placeholder="请输入居住地址" maxlength="200"
       class="singleRow whiteDis" :disabled="!isEdit">
        <template slot="prepend">居 住 地 址 :</template>
      </el-input>
      <div style="margin-bottom: 20px;">
        <el-button class="dropDown">有 效 期 限 :</el-button>
        <el-date-picker type="date" v-model="ksTime" :editable="false" value-format="yyyy-MM-dd"
        placeholder="开始日期" style="width:23%;cursor:pointer;" :disabled="!isEdit"/> 至
        <el-date-picker type="date" v-model="jsTime" :editable="false" value-format="yyyy-MM-dd"
        placeholder="结束日期" style="width:23%;cursor:pointer;" :disabled="!isEdit || yxqxTwo"/>
        <el-checkbox v-model="yxqxTwo" style="margin-left: 10px;" :disabled="!isEdit">长期有效</el-checkbox>
      </div>
    </el-col>
  </el-row>

  <el-row :gutter="20">
    <el-col :span="12">
      <p class="modtTitle">结算账户</p>
      <div class="elGroup">
        <el-button class="btnGroup">账户类型 :</el-button>
        <el-radio-group v-model="zhlx" :disabled="!isEdit">
          <el-radio :label="74" :disabled='ztlx == 2'>对公账户</el-radio>
          <el-radio :label="75" v-show="ztlx == 4">对私账户</el-radio>
        </el-radio-group>
      </div>
      <!-- <el-input v-model="kaihuBank" placeholder="公/私" maxlength="15" class="singleRow">
        <template slot="prepend">开户银行 :</template>
      </el-input> -->
      <div style="margin-bottom: 20px;">
        <el-button class="dropDown">开户银行 :</el-button>
        <el-button type="primary" size="small" @click="choiceRange()" v-show="isEdit">选择开户银行</el-button>
        <b style="margin-left: 10px">{{kaihuBank}}</b>
      </div>
      
      <el-input v-model="kaihuName" placeholder="公（企业名称）  /    私  法人(经营者)姓名" maxlength="15"
      class="singleRow whiteDis" disabled> <template slot="prepend">开户名称 :</template>
      </el-input>
      <!-- <el-input v-model="kaihuCity" placeholder="精确到市" maxlength="15" class="singleRow">
        <template slot="prepend">开户城市 :</template>
      </el-input> -->
      <div style="margin-bottom: 20px;">
        <el-button class="dropDown">开户城市 :</el-button>
        <!-- <el-select v-model="kaihuCity" filterable placeholder="请选择" style="width:66.6%">
          <el-option v-for="(item,index) in nrModeArr" :key="index" :label="item.Name" :value="item.Id"/>
        </el-select> -->
        <el-select v-model="provinceId" placeholder="请选择省份" @change="changeProvince" style="width:33%;" :disabled="!isEdit">
          <el-option :label="item.province_name" :value="item.province_code" v-for="(item,index) in tbdprovince" :key="index"/>
        </el-select>
        <el-select v-model="cityId" placeholder="请选择城市" @change="changeCity" style="width:33%;" :disabled='!isEdit || !provinceId'>
          <el-option :label="item.city_name" :value="item.city_code" v-for="(item,index) in tbdcity" :key="index"/>
        </el-select>
      </div>
      <div style="margin-bottom: 20px;" v-show="needBankBranch == true">
        <el-button class="dropDown">开户支行 :</el-button>
        <el-select v-model="kaihuzhId" filterable placeholder="请输入支行或12位银行联行号" @change="changeSubBranch" style="width:66.6%">
          <el-option v-for="(item,index) in zhihangArr" :key="index" :label="item.bank_branch_name" :value="item.bank_branch_id"/>
        </el-select>
      </div>
      <el-input v-model="bankzh" placeholder="请输入银行账号" maxlength="30" class="singleRow whiteDis" :disabled="!isEdit">
        <template slot="prepend">银行账号 :</template>
      </el-input>
    </el-col>
    <el-col :span="12">
      <p class="modtTitle">资金管理员 <span class="zjgly">(主要负责签约微信商户支付，并可接收日常重要管理信息和进行资金操作</span>
        <el-button type="text" @click="fundManager = true" class="xiugai" v-show="statusId == 'FINISH'">修改</el-button>
      </p>
      <div class="elGroup">
        <el-button class="btnGroup">管理员类型 :</el-button>
        <el-radio-group v-model="glylx" :disabled="!isEdit">
          <el-radio :label="65">经营者/法人</el-radio>
          <el-radio :label="66">经办人</el-radio>
        </el-radio-group>
      </div>
      <div class="rxgh" v-show="glylx == 66">
        <div class="rxghDiv">
          <el-image :src="glyRxImgL" v-if="glyRxImgL" class="rxghAvatarImg" @click="handleClickItem" :preview-src-list="[glyRxImgL]"/>
          <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 4)">
            <i class="el-icon-plus rxghUploader"></i>
          </el-upload>
          <img src="../../assets/img/aicon36.png" class="chahao" @click.stop="delIDcard(4)" v-show="isEdit && glyRxImgL"/>
          <p class="rxghSM"> 管理员身份证正面（人像） </p>
        </div>
        <div class="rxghDiv">
          <el-image :src="glyGhImgL" v-if="glyGhImgL" class="rxghAvatarImg" @click="handleClickItem" :preview-src-list="[glyGhImgL]"/>
          <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 5)">
            <i class="el-icon-plus rxghUploader"></i>
          </el-upload>
          <img src="../../assets/img/aicon36.png" class="chahao" @click.stop="delIDcard(5)" v-show="isEdit && glyGhImgL"/>
          <p class="rxghSM"> 管理员身份证反面（国徽） </p>
        </div>
      </div>
      <div v-show="glylx == 65">
        <el-input v-model="glyNameOne" placeholder="请输入姓名" maxlength="10" class="singleRow whiteDis" :disabled="!isEdit">
          <template slot="prepend">管理员姓名 :</template>
        </el-input>
        <el-input v-model="glySfzhmOne" placeholder="请输入18位身份证号码" maxlength="18" class="singleRow whiteDis" :disabled="!isEdit">
          <template slot="prepend">身份证号码 :</template>
        </el-input>
      </div>
      <div v-show="glylx == 66">
        <el-input v-model="glyNameTwo" placeholder="请输入姓名" maxlength="10" class="singleRow whiteDis" :disabled="!isEdit">
          <template slot="prepend">管理员姓名 :</template>
        </el-input>
        <el-input v-model="glySfzhmTwo" placeholder="请输入18位身份证号码" maxlength="18" class="singleRow whiteDis" :disabled="!isEdit">
          <template slot="prepend">身份证号码 :</template>
        </el-input>
      </div>
      <div style="margin-bottom: 20px;" v-show="glylx == 66">
        <el-button class="dropDown">有 效 期 限 : </el-button>
        <el-date-picker type="date" v-model="startTime" :editable="false" value-format="yyyy-MM-dd"
        placeholder="开始日期" style="width:26%;cursor:pointer;" :disabled="!isEdit"/> 至
        <el-date-picker type="date" v-model="endTime" :editable="false" value-format="yyyy-MM-dd"
        placeholder="结束日期" style="width:26%;cursor:pointer;" :disabled="!isEdit || yxqxThree"/>
        <el-checkbox v-model="yxqxThree" style="margin-left: 10px;" :disabled="!isEdit">长期有效</el-checkbox>
      </div>
      <el-input v-model="glyEmail" placeholder="请填写常用邮箱（推荐网易邮箱和腾讯邮箱）" maxlength="25"
       class="singleRow whiteDis" :disabled="!isEdit">
        <template slot="prepend">管理员邮箱 :</template>
      </el-input>
      <el-input v-model="glyPhone" placeholder="（用于接受微信支付的重要管理信息及日常操作验证码）" maxlength="11"
       class="singleRow whiteDis" :disabled="!isEdit">
        <template slot="prepend">管理员手机 :</template>
      </el-input>
      <div style="margin-bottom: 20px;" v-show="glylx == 66">
        <div class="sqhPic">
          <el-button class="dropDown">业务办理授权函 :</el-button>
          <el-image :src="sqhLong" v-if="sqhLong" class="sqhImg" @click="handleClickItem" :preview-src-list="[sqhLong]"/>
          <el-upload v-else class="avatar-uploader" action accept=".jpg, .png" :show-file-list="false" :before-upload="(file)=>beforeIDcard(file, 6)">
            <i class="el-icon-plus sqhIcon"></i>
          </el-upload>
          <img src="../../assets/img/aicon36.png" class="sqhDel" @click.stop="delIDcard(6)" v-show="isEdit && sqhLong"/>
        </div>
        <ul class="ywblsqh">
          <li>提示：</li>
          <li>1、 扫描件或照片大小不得超过2M，所有材料均需清晰可见，不支持截图、翻拍、镜像照片；</li>
          <li>2、 授权函的信息全部需打印，除经营者签字外，其余不支持手写商户信息；</li>
          <li>3、 右下角单位名称和盖章日期请勿留空；</li>
          <li>4、 商户均应当在“单位（盖章）”处加盖主体公章鲜章，个体户应由经营者本人手写正楷签字并加盖手印。如个体户未刻制公章的，则以第5条规则为准；</li>
          <li>5、 个体户未刻制公章的，应在“经营者（签字捺印）”处，说明“无公章”并由经营者本人手写正楷签字及加盖手印；</li>
          <li>6、 业务办理授权函盖章有效期需为90天内。</li>
          <li>7、 点击这里“<el-button type="text" @click="onYwblsqh">业务办理授权函</el-button>”模板；</li>
        </ul>
      </div>
    </el-col>
  </el-row>
  
  <!-- 底部操作按钮 -->
  <div class="gudingdibu" v-show="bbid">
    <el-button type="danger" @click="emit()" v-show="resultCodeFour == 4 || statusId == 'READDY' || statusId == null">保存草稿</el-button>
    <el-button @click="goback()" v-show="ismark">取消</el-button>
    <el-button type="danger" @click="tjsh()" v-show="isEdit">{{ ismark?'重新提交申请':'提交申请' }}</el-button>
    <el-button type="danger" @click="goChange()" v-show="isinfo">变更信息</el-button>
  </div>

  <!-- 弹框区域 -->
  <el-dialog title='选择开户银行' :visible.sync="bankofDeposit" @closed="clearBank" width="35%" center>
    <el-input placeholder="请输入搜索内容" v-model="inputKhyh" class="searchKhyh">
      <el-button slot="append" icon="el-icon-search" @click="handleSearch()">搜索</el-button>
    </el-input>
    <div class="dropdown-container">
      <div v-for="(item, index) in rmyhArr" :key="index" class="rmyhQuick">
        <span :class="currentIndex === index ?'rmyhClass':'spanTitle'" @click="handleItem(index)">{{item.name}}</span>
      </div>
      <el-radio-group v-model="radio" class="radio-container" @change="setBank">
        <el-dropdown-item v-for="(item, i) in bankList" :key="i">
          <el-radio-button :label="item.bank_alias_code" class="radioBtn"><span>{{ item.bank_alias }}</span></el-radio-button>
        </el-dropdown-item>
      </el-radio-group>
    </div>
  </el-dialog>

  <!-- 打款信息 -->
  <el-dialog title='打款信息' :visible.sync="dkDialog" @closed="clearDkImg" width="35%" center>
    <ul class="dkClass">
      <li>付款用户：<span>{{accountValidation.account_name}}</span></li>
      <li v-show="accountValidation.account_no">付款卡号：<span>{{accountValidation.account_no}}</span></li>
      <li>汇款金额：<span>{{accountValidation.pay_amount}}</span></li>
      <li>收款卡号：<span class="dkColor">{{accountValidation.destination_account_number}}</span></li>
      <li>收款户名：<span class="dkColor">{{accountValidation.destination_account_name}}</span></li>
      <li>开户银行：<span class="dkColor">{{accountValidation.destination_account_bank}}</span></li>
      <li>省市信息：<span class="dkColor">{{accountValidation.city}}</span></li>
      <li>备注信息：<span class="dkColor">{{accountValidation.remark}}</span></li>
      <li>汇款截止时间：<span class="dkColor">{{accountValidation.deadline}}</span></li>
    </ul>
    <div style="text-align:center">
      <el-button type="primary" @click="dkDialog = false">关闭</el-button>
    </div>
  </el-dialog>
  
  <!-- 修改资金管理员 -->
  <el-dialog title="修改资金管理员" :visible.sync="fundManager" width="30%" center>
    <p class="zjglinfo">请点击“去修改”按钮跳转到微信商户支付平台，使用现资金管理员微信扫一扫进行登录，登录成功后点击账户中心进行操作修改。（或浏览器输入https://pay.weixin.qq.com ）</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click="fundManager = false">取 消</el-button>
      <el-button type="danger" @click="makedes()">去修改</el-button>
    </div>
  </el-dialog>

  <!-- 收款设置提示 -->
  <el-dialog title="收款设置提示" :visible.sync="sksztx" width="25%" :center="true" @close="cancelFun()">
    <p style="font-size: 18px;">您的企业下还没有一家店铺，请先创建一个店铺后，再来设置收款信息。</p>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="goOpen()">去开店</el-button>
    </div>
  </el-dialog>
  
  <!-- 初始化弹框 -->
  <el-dialog title="请选择企业" :visible.sync="dialogSksz" width="25%" center>
    <el-form class="findform">
      <el-form-item label="企业名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择企业" @change="handleChangeQymc">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, getenterprise, toolsOcr } from '../../api/newOss';
import { newGetStaffEnterprise } from "../../api/attractInvestment";
import { getBanking, getBranches, getProvinces, getCities, postSaveDemo, getSeeDetails, postSubmit, getHasShop } from "../../api/shopWindow";
export default {
  name: "collectionSettings",
  mixins: [alertTrends],
  data() {
    return {
      ztlx: 2, // 主体类型
      withdrawerName: '', // 商户简称

      zhlx: 74, // 账户类型
      kaihuBank: '', // 开户银行
      kaihuName: '', // 开户名称
      kaihuCity: '', // 开户城市
      kaihuzhId: '', // 开户支行-id
      kaihuzhName: '', // 开户支行-name
      bankzh: '', // 银行账号

      glylx: 65, // 管理员类型
      glyNameOne: '', // 管理员姓名
      glySfzhmOne: '', // 身份证号码
      glyNameTwo: '', // 管理员姓名
      glySfzhmTwo: '', // 身份证号码
      startTime: '', // 开始时间
      endTime: '', // 结束时间
      yxqxThree: false, // 长期有效 默认勾选
      glyEmail: '', // 管理员邮箱
      glyPhone: '', // 管理员手机
      
      nrModeArr: [
        {
          Id: 1,
          Name: "北京"
        },
        {
          Id: 2,
          Name: "天津"
        },
      ],
      zhihangArr:[],

      qymc: '', // 企业名称
      qyfr: '', // 企业法人
      xydm: '', // 信用代码
      kssj: '', // 有效期限-开始时间
      jssj: '', // 有效期限-结束时间
      yxqxOne: false, // 长期有效 默认勾选
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },

      sfzxm: '', // 身份证姓名
      sfzhm: '', // 身份证号码
      jzdz: '', // 居住地址
      ksTime: '', // 开始时间
      jsTime: '', // 有效期限
      yxqxTwo: false, // 长期有效 默认勾选
      legalpersonIdcardInstitution: '', // 发证机关

      yyzzLong: '', // 营业执照 - 长连接
      yyzzShort: '', // 营业执照 - 短连接
      
      rxLong: '', // 人像 - 长连接
      rxShort: '', // 人像 - 短连接
      
      ghLong: '', // 国徽 - 长连接
      ghShort: '', // 国徽 - 短连接

      glyRxImgL: '', // 管理员人像 - 长连接
      glyRxImgS: '', // 管理员人像 - 短连接

      glyGhImgL: '', // 管理员国徽 - 长连接
      glyGhImgS: '', // 管理员国徽 - 短连接

      sqhLong: '', // 业务办理授权函 - 长连接
      sqhShort: '', // 业务办理授权函 - 短连接
      
      idInfo: {}, // 身份证信息回填
      
      bankofDeposit: false, // 开户银行-弹框
      inputKhyh: '', // 搜索参数
      radio: "",
      currentIndex: 0, //当前索引
      rmyhArr: [
        {
          name: '常用银行'
        },
        {
          name: 'ABCDEF'
        },
        {
          name: 'GHIJKL'
        },
        {
          name: 'MNOP'
        },
        {
          name: 'QRSTU'
        },
        {
          name: 'VWXYZ'
        },
      ],
      bankList: [],
      bankAliasCode: '', // 银行别名编码
      accountBank: '', // 开户银行
      needBankBranch: false, // 是否需要填写支行
      
      provinceId: '', // 省
      provinceName: '', // 省名称
      cityId: '', // 市
      cityName: '', // 市名称
      tbdprovince: [],
      tbdcity: [],
      newbbId: '', // 店铺id
      
      shopName: '', // 店铺名称
      statusId: '', // 状态id
      currentState: '准备资料阶段', // 当前状态：准备资料阶段-资料校验中-待账户验证-审核中-已驳回-待签约-已完成-已冻结

      // 微信审核信息
      applymentState: '', // 申请状态
      describe: '', // 阶段描述
      signState: '', // 签约状态 - 二维码显隐
      signUrl: '', // 签约链接
      legalUrl: '', // 法人验证链接（base64二维码图片）
      accountValidation: {}, // 汇款账户验证信息
      dkDialog: false, // 打款信息

      resultCodeFour: 4, // 处理返回4的情况
      fundManager: false,

      dialogSksz: false, // 收款设置
      bbid:'',  // 企业id
      options1: [],

      sksztx: false, // 收款设置提示
      isEdit: true,
      ismark: false, // 取消按钮标识
      isinfo: false, // 变更信息
    };
  },
  computed: {
    isEdit() {
      return this.resultCodeFour == 4 || (this.statusId == 'READDY' || this.statusId == 'REJECTED' || this.statusId == 'CANCELED');
    }
  },
  methods: {
    makedes () {
      window.open('https://pay.weixin.qq.com');
    },
    // 业务办理授权函
    onYwblsqh() {
      window.open('https://taozhuanr-real.oss-cn-beijing.aliyuncs.com/Doc/业务办理授权函模板.docx');
    },
    // 查看 - 打款信息
    seePaymentInfo(){
      this.dkDialog = true;
    },
    // 关闭 - 打款信息
    clearDkImg(){
      this.dkDialog = false;
    },
    // 选择开户银行
    choiceRange(){
      this.bankofDeposit = true;
      this.inputKhyh = '';
      this.openBank(); // 获取开户银行数据
    },
    // 关闭-开户银行
    clearBank(){
      this.bankofDeposit = false;
    },
    // 搜索
    handleSearch(){
      this.openBank(); // 获取开户银行数据
    },
    // 常用银行
    handleItem(index) {
      this.currentIndex = index;
      this.openBank(); // 获取开户银行数据
    },
    // 选中值
    setBank(e) {
      // this.kaihuBank = this.bankList[Number(e) - 1].bank_alias;
      let optBank = this.bankList.find(item=>item.bank_alias_code == e);
      this.kaihuBank = optBank.bank_alias; // 银行名称
      this.bankAliasCode = optBank.bank_alias_code; // 银行别名编码
      this.accountBank = optBank.account_bank; // 开户银行
      this.needBankBranch = optBank.need_bank_branch; // 是否需要填写支行
      
      this.bankofDeposit = false;
    },
    
    // 开户银行-数据
    openBank() {
      let obj = {
        type: this.zhlx, // 类型 1=对私、2=对公
        selectType: this.currentIndex, // 查询类型 0=常用银行 1=ABCDEF 2=GHIJKL 3=MNOP 4=QRSTU 5=VWXYZ
        key: this.inputKhyh, // 关键字
      };
      getBanking(obj).then(data => {
        if (data.resultCode == 1) {
          this.bankList = data.resultObj.resultObj;
          // this.total = data.resultObj.rowsCount;
        }
      });
    },
    // 初始化-回显
    init() {
      let obj = {
        // bbid: localStorage.businessBbId, // 店铺id
        eid: this.bbid, // 企业id
      }
      getSeeDetails(obj).then(data=>{
        if(data) {
        if(data.resultCode == 1){
          this.resultCodeFour = '';
          let seeDataObj = data.resultObj.details; // 收款设置数据
          this.newbbId = seeDataObj.bbId // 店铺id
          this.ztlx = Number(seeDataObj.organizationType) // 主体类型
          this.withdrawerName = seeDataObj.merchantShortName // 商户简称
          this.yyzzLong = seeDataObj.businessLicenseCopyUrl // 营业执照
          this.qymc = seeDataObj.merchantName // 企业名称
          this.qyfr = seeDataObj.legalPerson // 企业法人
          this.xydm = seeDataObj.businessLicenseNumber // 信用代码
          this.kssj = seeDataObj.businessTimeBegin // 有效期限-开始时间
          if(seeDataObj.businessTimeEnd == '长期') {
            this.yxqxOne = true;
            this.jssj = '';
          } else {
            this.yxqxOne = false;
            this.jssj = seeDataObj.businessTimeEnd // 有效期限-结束时间
          }
          
          this.rxLong = seeDataObj.idCardCopyUrl // 身份证人像面
          this.ghLong = seeDataObj.idCardNationalUrl // 身份证国徽面
          this.sfzxm = seeDataObj.idCardName // 身份证姓名
          this.sfzhm = seeDataObj.idCardNumber // 身份证号码
          this.jzdz = seeDataObj.idCardAddress // 居住地址 身份证居住地址（选填） 1、主体类型为企业时，需要填写。个体工商户类型，无需上传。
          this.ksTime = seeDataObj.idCardValidTimeBegin // 开始时间 身份证开始时间（必填） 1.格式：yyyy-MM-dd
          if(seeDataObj.idCardValidTime == '长期') {
            this.yxqxTwo = true;
            this.jsTime = '';
          } else {
            this.yxqxTwo = false;
            this.jsTime = seeDataObj.idCardValidTime // 有效期限
          }
          this.legalpersonIdcardInstitution = seeDataObj.legalpersonIdcardInstitution?seeDataObj.legalpersonIdcardInstitution:''; // 发证机关
          
          this.zhlx = seeDataObj.bankAccountType?Number(seeDataObj.bankAccountType):74 // 账户类型
          this.accountBank = seeDataObj.accountBank // 开户银行
          this.kaihuBank = seeDataObj.bankAlias // 银行别名
          this.bankAliasCode = seeDataObj.bankAliasCode // 银行别名编码
          this.kaihuName = this.zhlx==74?this.qymc:this.qyfr // 开户名称
          this.provinceId = seeDataObj.bankAddressProvincesCode? Number(seeDataObj.bankAddressProvincesCode) : '' // 省份编码
          this.provinceName = seeDataObj.bankAddressProvincesName // 省份名称
          this.cityId = seeDataObj.bankAddressCityCode? Number(seeDataObj.bankAddressCityCode) : '' // 城市编码
          this.cityName = seeDataObj.bankAddressCityName // 城市名称
          this.needBankBranch = seeDataObj.needBankBranch // 是否需要填写支行
          this.kaihuzhName = seeDataObj.bankName // 开户银行全称（含支行）
          this.kaihuzhId = seeDataObj.bankBranchId // 开户银行联行号
          this.bankzh = seeDataObj.accountNumber // 银行账号
          
          this.glylx = Number(seeDataObj.contactType) // 管理员类型
          this.glyRxImgL = seeDataObj.contactIdDocCopy // 超级管理员证件正面照片
          this.glyGhImgL = seeDataObj.contactIdDocCopyBack // 超级管理员证件反面照片
          this.glyNameOne = seeDataObj.contactName // 管理员姓名
          this.glySfzhmOne = seeDataObj.contactIdCardNumber // 身份证号码
          this.glyNameTwo = seeDataObj.contactName // 管理员姓名
          this.glySfzhmTwo = seeDataObj.contactIdCardNumber // 身份证号码
          this.startTime = seeDataObj.contactIdDocPeriodBegin // 超级管理员证件有效期开始时间
          if(seeDataObj.contactIdDocPeriodEnd == '长期') {
            this.yxqxThree = true;
            this.endTime = '';
          } else {
            this.yxqxThree = false;
            this.endTime = seeDataObj.contactIdDocPeriodEnd // 超级管理员证件有效期结束时间
          }
          this.glyEmail = seeDataObj.contactEmail // 管理员邮箱
          this.glyPhone = seeDataObj.mobilePhone // 管理员手机
          this.sqhLong = seeDataObj.businessAuthorizationLetter // 业务办理授权函
          
          this.statusId = seeDataObj.status // 状态id
          // this.statusId = 'CHECKING' // 状态id 固定值
          this.currentState = seeDataObj.statusName // 当前状态名称
          // 状态名称
          // READDY:草稿
          // CHECKING:资料校验中
          // ACCOUNT_NEED_VERIFY:待账户验证
          // AUDITING:审核中
          // REJECTED:已驳回
          // NEED_SIGN:待签约
          // FINISH:完成
          // FROZEN:已冻结
          // CANCELED:已作废
          if(this.statusId=='CHECKING' || this.statusId=='ACCOUNT_NEED_VERIFY' || this.statusId=='AUDITING' || this.statusId=='NEED_SIGN'){
            this.isEdit=false;
            this.isinfo=true;
          }

          let seeWeChat = data.resultObj.applyFrom?data.resultObj.applyFrom:[]; // 微信审核信息
          this.applymentState = seeWeChat.applyment_state // 申请状态
          this.describe = seeWeChat.applyment_state_desc // 阶段描述
          this.signState = seeWeChat.sign_state // 签约状态
          this.signUrl = seeWeChat.sign_url // 签约链接
          this.legalUrl = seeWeChat.legal_validation_url // 法人验证链接（base64二维码图片）
          this.accountValidation = seeWeChat.account_validation ? seeWeChat.account_validation:{} // 汇款账户验证信息
          if(this.provinceId) {
            this.getcity(); // 获取市
          }
        }
        } else {
          this.resultCodeFour = 4;
        }
      });
    },
    // 保存草稿
    emit() {
      let obj = {
        // bbId: localStorage.businessBbId, // 店铺id
        eid: this.bbid, // 企业id
        organizationType: this.ztlx, // 主体类型  2=企业、4=个体工商户
        merchantShortName: this.withdrawerName, // 商户简称
        businessLicenseCopyUrl: this.yyzzLong, // 营业执照图片路径
        merchantName: this.qymc, // 企业名称
        legalPerson: this.qyfr, // 企业法人姓名
        businessLicenseNumber: this.xydm, // 信用代码
        businessTimeBegin: this.kssj, // 营业执照开始时间   string类型  格式  yyyy-MM-dd
        businessTimeEnd: this.yxqxOne ? this.jssj = '长期' : this.jssj, // 有效期限结束时间（可传“长期”）
        idCardCopyUrl: this.rxLong, // 身份证人像面图片路径
        idCardNationalUrl: this.ghLong, // 身份证国徽面图片路径
        idCardName: this.sfzxm, // 身份证姓名
        idCardNumber: this.sfzhm, // 身份证号码
        idCardAddress: this.jzdz, // 居住地址 身份证居住地址（选填） 1、主体类型为企业时，需要填写。个体工商户类型，无需上传。
        idCardValidTimeBegin: this.ksTime, // 开始时间 身份证开始时间（必填） 1.格式：yyyy-MM-dd
        idCardValidTime: this.yxqxTwo ? this.jsTime = '长期' : this.jsTime, // 身份证有效期限
        legalpersonIdcardInstitution: this.legalpersonIdcardInstitution?this.legalpersonIdcardInstitution:'', // 发证机关

        bankAccountType: this.zhlx, // 账户类型 企业写死：74-对公账户。个体工商户可选：74-对公账户、75-对私账户。
        accountBank: this.accountBank, // 开户银行（弹框选择）
        bankAlias: this.kaihuBank, // 银行别名
        bankAliasCode: this.bankAliasCode, // 银行别名编码
        accountName: this.kaihuName, // 开户名称
        bankAddressProvincesCode: this.provinceId, // 银行开户省份编码
        bankAddressProvincesName: this.provinceName, // 银行开户省份名称
        bankAddressCityCode: this.cityId, // 银行开户城市编码
        bankAddressCityName: this.cityName, // 银行开户城市名称
        needBankBranch: this.needBankBranch, // 是否需要填写支行
        bankName: this.needBankBranch?this.kaihuzhName:'', // 开户银行全称（含支行）
        bankBranchId: this.needBankBranch?this.kaihuzhId:'', // 开户银行联行号
        accountNumber: this.bankzh, // 银行账号
        contactType: this.glylx, // 管理员类型：65-经营者/法人、66- 经办人。
        contactIdDocCopy: this.glyRxImgL, // 超级管理员证件正面照片
        contactIdDocCopyBack: this.glyGhImgL, // 超级管理员证件反面照片
        contactName: this.glylx == 65?this.glyNameOne:this.glyNameTwo, // 管理员姓名
        contactIdCardNumber: this.glylx == 65?this.glySfzhmOne:this.glySfzhmTwo, // 管理员身份证号
        contactIdDocPeriodBegin: this.startTime, // 超级管理员证件有效期开始时间
        contactIdDocPeriodEnd: this.yxqxThree?this.endTime='长期':this.endTime, // 超级管理员证件有效期结束时间
        contactEmail: this.glyEmail, // 管理员邮箱
        mobilePhone: this.glyPhone, // 管理员手机
        businessAuthorizationLetter: this.sqhLong, // 业务办理授权函
      };
      postSaveDemo(obj).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('保存草稿成功', 'success');
        }
      });
    },

    // 提交审核
    tjsh() {
      
      // if (Number(this.jundan) < 1) {
      //   this.showAlert('均单价格需要大于0');
      //   return false;
      // }

      if (this.withdrawerName == '') {
        this.showAlert('请输入商户简称');
        return false;
      }
      if (this.kaihuBank == "") {
        this.showAlert('请选择开户银行');
        return false;
      }
      // if (this.kaihuName == "") {
      //   this.showAlert('请输入开户名称');
      //   return false;
      // }
      // if (this.kaihuCity == "") {
      //   this.showAlert('请选择开户城市');
      //   return false;
      // }
      if (this.provinceId == '') {
        this.showAlert('请选择所在省');
        return false;
      }
      if (this.cityId == '') {
        this.showAlert('请选择所在市');
        return false;
      }
      if (this.needBankBranch == true && this.kaihuzhId == "") {
        this.showAlert('请输入支行或12位银行联行号');
        return false;
      }
      if(this.bankzh == '') {
        this.showAlert('请输入银行账号');
        return false;
      }

      if(this.glylx == 65) {
        if(this.glyNameOne == '') {
          this.showAlert('请输入管理员姓名');
          return false;
        }
        if(this.glySfzhmOne == '') {
          this.showAlert('请输入身份证号码');
          return false;
        }
      }
      if(this.glylx == 66) {
        if(this.glyNameTwo == '') {
          this.showAlert('请输入管理员姓名');
          return false;
        }
        if(this.glySfzhmTwo == '') {
          this.showAlert('请输入身份证号码');
          return false;
        }
      }
      
      if(this.glyEmail == '') {
        this.showAlert('请输入管理员邮箱');
        return false;
      }
      if(this.glyPhone == '') {
        this.showAlert('请输入管理员手机');
        return false;
      }
      if(this.glylx == 66 && this.sqhLong == '') {
        this.showAlert('请上传业务办理授权函图片');
        return false;
      }

      if(this.ismark){
        this.$swal({
          type: "warning",
          text: "确定要重新提交申请吗？",
          showCancelButton: true,
          reverseButtons: true, // 添加这一行来反转按钮顺序
          cancelButtonText: "取消",
          confirmButtonText: "确定",
        }).then(res => {
          if (res.value) {
            this.tjSubmit(); // 重新提交申请
          }
        });
      }else{
        this.tjSubmit(); // 提交申请
      }
      
    },
    // 提交接口
    tjSubmit(){
      let obj = {
        // bbId: localStorage.businessBbId, // 店铺id
        eid: this.bbid, // 企业id
        organizationType: this.ztlx, // 主体类型  2=企业、4=个体工商户
        merchantShortName: this.withdrawerName, // 商户简称
        businessLicenseCopyUrl: this.yyzzLong, // 营业执照图片路径
        merchantName: this.qymc, // 企业名称
        legalPerson: this.qyfr, // 企业法人姓名
        businessLicenseNumber: this.xydm, // 信用代码
        businessTimeBegin: this.kssj, // 营业执照开始时间   string类型  格式  yyyy-MM-dd
        businessTimeEnd: this.yxqxOne ? this.jssj = '长期' : this.jssj, // 有效期限结束时间（可传“长期”）
        idCardCopyUrl: this.rxLong, // 身份证人像面图片路径
        idCardNationalUrl: this.ghLong, // 身份证国徽面图片路径
        idCardName: this.sfzxm, // 身份证姓名
        idCardNumber: this.sfzhm, // 身份证号码
        idCardAddress: this.jzdz, // 居住地址 身份证居住地址（选填） 1、主体类型为企业时，需要填写。个体工商户类型，无需上传。
        idCardValidTimeBegin: this.ksTime, // 开始时间 身份证开始时间（必填） 1.格式：yyyy-MM-dd
        idCardValidTime: this.yxqxTwo ? this.jsTime = '长期' : this.jsTime, // 身份证有效期限
        legalpersonIdcardInstitution: this.legalpersonIdcardInstitution?this.legalpersonIdcardInstitution:'', // 发证机关

        bankAccountType: this.zhlx, // 账户类型 企业写死：74-对公账户。个体工商户可选：74-对公账户、75-对私账户。
        accountBank: this.accountBank, // 开户银行（弹框选择）
        bankAlias: this.kaihuBank, // 银行别名
        bankAliasCode: this.bankAliasCode, // 银行别名编码
        accountName: this.kaihuName, // 开户名称
        bankAddressProvincesCode: this.provinceId, // 银行开户省份编码
        bankAddressProvincesName: this.provinceName, // 银行开户省份名称
        bankAddressCityCode: this.cityId, // 银行开户城市编码
        bankAddressCityName: this.cityName, // 银行开户城市名称
        needBankBranch: this.needBankBranch, // 是否需要填写支行
        bankName: this.needBankBranch?this.kaihuzhName:'', // 开户银行全称（含支行）
        bankBranchId: this.needBankBranch?this.kaihuzhId:'', // 开户银行联行号
        accountNumber: this.bankzh, // 银行账号
        contactType: this.glylx, // 管理员类型：65-经营者/法人、66- 经办人。
        contactIdDocCopy: this.glyRxImgL, // 超级管理员证件正面照片
        contactIdDocCopyBack: this.glyGhImgL, // 超级管理员证件反面照片
        contactName: this.glylx==65?this.glyNameOne:this.glyNameTwo, // 管理员姓名
        contactIdCardNumber: this.glylx==65?this.glySfzhmOne:this.glySfzhmTwo, // 管理员身份证号
        contactIdDocPeriodBegin: this.startTime, // 超级管理员证件有效期开始时间
        contactIdDocPeriodEnd: this.yxqxThree?this.endTime='长期':this.endTime, // 超级管理员证件有效期结束时间
        contactEmail: this.glyEmail, // 管理员邮箱
        mobilePhone: this.glyPhone, // 管理员手机
        businessAuthorizationLetter: this.sqhLong, // 业务办理授权函
      };
      postSubmit(obj).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('提交申请成功', 'success');
          this.init(); // 调取回显接口
        }
      });
    },
    // 取消
    goback() {
      this.$swal({
        type: "warning",
        text: "确定要取消变更吗？",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then(res => {
        if (res.value) {
          this.isEdit=false;
          this.ismark=false;
          this.isinfo=true;
          this.init(); // 调取回显接口
        }
      });
    },
    // 变更信息
    goChange() {
      this.$swal({
        type: "warning",
        text: "确定要对当前审核中的收款设置信息进行变更吗？",
        showCancelButton: true,
        reverseButtons: true, // 添加这一行来反转按钮顺序
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then(res => {
        if (res.value) {
          this.isEdit=true;
          this.ismark=true;
          this.isinfo=false;
        }
      });
    },

    // 营业执照 & 人像 & 国徽 & 管理员人像 & 管理员国徽 & 业务办理授权函
    beforeIDcard(file, type) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 2;
      if (!isJPG) {
        this.showAlert('上传图片只支持jpg、png等格式!');
        return;
      }
      if (!isLt2M) {
        this.showAlert('上传图片大小不能超过2MB!');
        return;
      }
      var that = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        that.handleOss(43); // oss 直传图片
        var newOssPic = await uploadOSS(file,0);
        if(type == 1){
          that.yyzzLong = newOssPic; // 营业执照 - 长连接
          that.yyzzShort = newOssPic.replace(localStorage.BaseOssUrl,'') // 营业执照 - 短链接
          if(that.yyzzLong){
            that.seeInfo(that.yyzzLong,2);
          }
        }
        if(type == 2){
          that.rxLong = newOssPic; // 人像 - 长连接
          that.rxShort = newOssPic.replace(localStorage.BaseOssUrl,'') // 人像 - 短链接
          if(that.rxLong){
            that.seeInfo(that.rxLong,1,1,1);
          }
        }
        if(type == 3){
          that.ghLong = newOssPic; // 国徽 - 长连接
          that.ghShort = newOssPic.replace(localStorage.BaseOssUrl,'') // 国徽 - 短链接
          if(that.ghLong){
            that.seeInfo(that.ghLong,1,2,1);
          }
        }
        if(type == 4){
          that.glyRxImgL = newOssPic; // 管理员人像 - 长连接
          that.glyRxImgS = newOssPic.replace(localStorage.BaseOssUrl,'') // 管理员人像 - 短链接
          if(that.glyRxImgL){
            that.seeInfo(that.glyRxImgL,1,1,2);
          }
        }
        if(type == 5){
          that.glyGhImgL = newOssPic; // 管理员国徽 - 长连接
          that.glyGhImgS = newOssPic.replace(localStorage.BaseOssUrl,'') // 管理员国徽 - 短链接
          if(that.glyGhImgL){
            that.seeInfo(that.glyGhImgL,1,2,2);
          }
        }
        if(type == 6){
          that.sqhLong = newOssPic; // 业务办理授权函 - 长连接
          that.sqhShort = newOssPic.replace(localStorage.BaseOssUrl,'') // 业务办理授权函 - 短链接
        }
      };
      return file;
    },
    // 删除 - 营业执照 & 人像 & 国徽 & 管理员人像 & 管理员国徽 & 业务办理授权函
    delIDcard(type) {
      if(type == 1){
        this.yyzzLong = '';
        this.yyzzShort = '';
      }
      if(type == 2){
        this.rxLong = '';
        this.rxShort = '';
      }
      if(type == 3){
        this.ghLong = '';
        this.ghShort = '';
      }
      if(type == 4){
        this.glyRxImgL = '';
        this.glyRxImgS = '';
      }
      if(type == 5){
        this.glyGhImgL = '';
        this.glyGhImgS = '';
      }
      if(type == 6){
        this.sqhLong = '';
        this.sqhShort = '';
      }
    },
    
    // 信息回填
    seeInfo(img, type, side, type2){
      let obj = {
        imgurl: img, // 全路径
        type: type,// 识别类型1=身份证 2=营业执照
      };
      toolsOcr(obj).then(data => {
        if (data.resultCode == 1) {
          const newInfo = data.resultObj;
          if (side === 1) { // 正面信息
            // 直接更新或合并信息
            Object.assign(this.idInfo, newInfo);
          } else if (side === 2) { // 反面信息
            // 合并反面特有的信息
            const backSpecificFields = ['issueAuthority', 'beginDate', 'endDate', 'ispermanent'];
            backSpecificFields.forEach(field => {
              if (newInfo[field]) {
                this.idInfo[field] = newInfo[field];
              }
            });
          }
          console.log(newInfo,'回填信息');
          if(type==2){ // 营业执照
            this.qymc = newInfo.companyName; // 企业名称
            this.qyfr = newInfo.legalPerson; // 企业法人
            this.xydm = newInfo.creditCode; // 信用代码
            this.kssj = newInfo.beginDate; // 开始
            this.jssj = newInfo.ispermanent==1?'':newInfo.endDate; // 结束
            this.yxqxOne = newInfo.ispermanent==1?true:false; // 是否长期有效 0=否 1=是
          }
          console.log(this.idInfo,'回填信息');
          if(type2==1){
            this.sfzxm = this.idInfo.name; // 法人姓名
            this.sfzhm = this.idInfo.idNumber; // 身份证号码
            this.jzdz = this.idInfo.address; // 居住地址
            this.ksTime = this.idInfo.beginDate; // 开始
            this.jsTime = this.idInfo.ispermanent==1?'':this.idInfo.endDate; // 结束
            this.yxqxTwo = this.idInfo.ispermanent==1?true:false; // 是否长期有效 0=否 1=是
            this.legalpersonIdcardInstitution = this.idInfo.issueAuthority?this.idInfo.issueAuthority:''; // 发证机关
          }
          if(type2==2){
            this.glyNameTwo = this.idInfo.name; // 管理员姓名
            this.glySfzhmTwo = this.idInfo.idNumber; // 身份证号码
            this.startTime = this.idInfo.beginDate; // 开始
            this.endTime = this.idInfo.ispermanent==1?'':this.idInfo.endDate; // 结束
            this.yxqxThree = this.idInfo.ispermanent==1?true:false; // 是否长期有效 0=否 1=是
          }
        } else {
          this.showAlert(data.resultMsg);
        }
      })
      
      // this.idInfo = {
      //   "name": "曹长江",
      //   "sex": "男",
      //   "ethnicity": "汉",
      //   "birthDate": "1980年4月6日",
      //   "address": "北京市大兴区黄村镇兴涛园小区56号楼3单元1502号",
      //   "idNumber": "211382198004063912",
        
      //   "issueAuthority": "北京市公安局大兴分局",
      //   "validPeriod": "2021.11.04-2041.11.04",
      //   "beginDate": "2021-11-04",
      //   "endDate": "2041-11-04",
      //   "ispermanent": 0
      // }
      
    },
    
    // 省
    changeProvince(val) {
      this.tbdprovince.filter(item => {
        if(item.province_code == val){
          this.provinceName = item.province_name;
        }
      })
      this.getcity();
      this.cityId = '';
    },
    // 市
    changeCity(val) {
      this.tbdcity.filter(item => {
        if(item.city_code == val){
          this.cityName = item.city_name;
        }
      })
    },
    // 查找省
    getprovince() {
      let that = this;
      getProvinces().then(data => {
        that.tbdprovince = data.resultObj;
      });
    },
    // 查找市
    getcity() {
      let that = this;
      let loginParams = {
        province_code: this.provinceId // 省份编码
      };
      getCities(loginParams).then(data => {
        that.tbdcity = data.resultObj;
      });
    },
    
    // 开户支行
    subBranch() {
      let obj = {
        bank_alias_code: this.bankAliasCode, // 银行别名编码
        city_code: this.cityId // 城市编码
      };
      getBranches(obj).then(data => {
        if (data.resultCode == 1) {
          this.zhihangArr = data.resultObj.resultObj;
        } else {
          this.zhihangArr = [];
        }
      });
    },
    // 获取开户支行-选中项name
    changeSubBranch(val) {
      this.zhihangArr.filter(item => {
        if(item.bank_branch_id == val){
          this.kaihuzhName = item.bank_branch_name;
        }
      })
    },
    // 企业下是否有店铺
    qysfydp() {
      let obj = {
        eid: this.bbid, // 企业id
      }
      getHasShop(obj).then(data => {
        if(data) {
        if (data.resultCode == 1) {
          // true=有、false=无
          if(data.resultObj) {
            this.init();
          } else {
            this.sksztx = true;
          }
        } else {
          console.log('查无数据');
        }
        } else {
          this.sksztx = true;
        }
      });
    },
    // 点击跳转-去开店
    goOpen() {
      let obj = {
        userId: localStorage.Id
      };
      newGetStaffEnterprise(obj).then(data => {
        if (data.resultCode == 1) {
          let newBbType = data.resultObj.bbType; // 企业类型 1=品牌建材、2=装修公司、3=个人设计师
          if(newBbType == 3) {
            this.showAlert('不能添加店铺');
            return false;
          } else {
            this.$router.push({
              path: "/seeFindshop",
              query: {
                type: 0,
                storeType: newBbType
              }
            });
          }
        }else {
          this.showAlert('不能添加店铺');
          return false;
        }
      });
    },
    cancelFun() {
      this.sksztx = false;
      this.bbid = ''; // 企业id 置成空
    },
    // 用户可查看的企业
    handleSksz(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      getenterprise(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              this.dialogSksz = true;
              this.options1 = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.dialogSksz = false;
              this.bbid = data.resultObj[0].id; // 企业id
              this.shopName = data.resultObj[0].name;
              this.qysfydp();
            }
            
          }
        }
      })
    },
    gonext(){
      if(this.bbid == ""){
        this.showAlert('请选择企业名称');
        return false;
      }
      this.qysfydp();
      // this.getDpsmjl(); // 查询列表
      this.dialogSksz = false;
    },
    /* oss 直传图片 */
    handleOss(val){
      let obj = { type: val };
      getOssFile(obj).then(data => {
        if (data.resultCode == 1) {
          let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
          let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
          let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
          let ossfile = data.resultObj.directory; // 保存路径
          let ossbucket = data.resultObj.bucket; // bucket
          localStorage.setItem('keyossId',ossId);
          localStorage.setItem('keyossSecret',ossSecret);
          localStorage.setItem('keyossHost',ossHost);
          localStorage.setItem('keyossfile',ossfile);
          localStorage.setItem('keyossbucket',ossbucket);
        }
      })
    },
    // 获取企业名称
    handleChangeQymc(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.shopName = item.name;
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },

  },
  mounted() {
    this.getprovince(); // 获取省
    this.handleSksz(); // 用户可查看的企业
  },
  
  watch: {
    // 监听主体类型
    'ztlx'(newV,oldV) {
      if(this.ztlx == 2) { // 如果是企业
        this.zhlx = 74; // 只能是对公
      }
    },
    // 监听 企业名称 & 身份证姓名
    'qymc'(newV,oldV) {
      if(this.zhlx == 74) {
        this.kaihuName = this.qymc?this.qymc:this.sfzxm; // 赋值开户名称
      }
    },
    // 监听企业法人
    'qyfr'(newV,oldV) {
      if(this.zhlx == 75) {
        this.kaihuName = this.qyfr;
        this.sfzxm = this.qyfr;
      }
    },
    // 账户类型
    'zhlx'(newV,oldV) {
      if(this.zhlx == 74) {
        this.kaihuName = this.qymc; // 企业名称
      } else {
        this.kaihuName = this.qyfr; // 企业法人
      }
    },
    // 监听身份证姓名
    'sfzxm'() {
      this.glyNameOne = this.sfzxm;
      if(this.zhlx == 75) {
        this.kaihuName = this.sfzxm;
        this.qyfr = this.sfzxm;
      }
    },
    // 监听身份证号码
    'sfzhm'() {
      this.glySfzhmOne = this.sfzhm;
    },
    // 管理员类型
    'glylx'(newV,oldV) {
      if(this.glylx == 65) {
        this.glyNameOne = this.sfzxm; // 管理员姓名
        this.glySfzhmOne = this.sfzhm; // 身份证号码
      }
    },
    // 监听-调取开户支行
    'cityId'(newV,oldV) {
      if(this.needBankBranch && this.cityId) {
        this.subBranch(); // 开户支行
      }
    },

    'yxqxOne'() {
      if(this.yxqxOne) {
        this.jssj = "";
      }
    },
    'yxqxTwo'() {
      if(this.yxqxTwo) {
        this.jsTime = "";
      }
    },
    'yxqxThree'() {
      if(this.yxqxThree) {
        this.endTime = '';
      }
    },
    
  },

};
</script>
<style scoped>
.skszWrap {
  width: 98%;
  margin: 10px auto;
  padding: 20px;
  margin-left: 10px;
}
/* title */
.modtTitle {
  height: 35px;
  line-height: 35px;
  background-color: #f2f2f2;
  margin: 0 auto;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  color: #333;
  padding-left: 15px;
  margin-bottom: 20px;
}
/* 详情页 - 单排宽度 */
.singleRow {
  width: 80%;
  margin-bottom: 20px;
}
.elGroup {
  width: 80%;
  height: 38px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  margin-bottom: 20px;
}
/* 单选样式 */
.btnGroup {
  border: none;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  background-color: #F5F7FA;
  color: #909399;
  margin-right: 20px;
}

/* 重要说明 */
.zysmUl {
  padding-bottom: 10px;
  padding-left: 0;
}
.zysmUl>li {
  line-height: 35px;
}

/* 开通微信收款状态 */
.dpmcRight {
  font-size: 12px;
  font-weight: normal;
  float: right;
  padding-right: 20px;
}
.ktwxskzt {
  width: 100%;
  display: flex;
  flex: 1;
}
.ktwxskzt>dd{
  width: 60%;
  line-height: 22px;
  margin-left: 0;
}
.ktwxskzt>dt{
  width: 40%;
  text-align: center;
  text-align: right;
}
/* 当前状态 */
.dqzt {
  color: #0099FF;
}
/* 资金管理员 */
.zjgly {
  font-size: 12px;
  color: #FF6666;
}
.xiugai {
  float: right;
  margin-right: 10px;
}
.zjglinfo {
  width: 86%;
  margin: 0 auto;
  font-size: 16px;
  line-height: 26px;
}

/* 下拉框样式 */
.dropDown {
  border: none;
  border: 1px solid #DCDFE6;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  background-color: #F5F7FA;
  color: #909399;
  margin-right: -5px;
}
/* 管理员手机号-说明 */
.phoneSM {
  width: 74%;
  color: #FF6666;
  text-align: center;
  margin-top: -12px;
}
/* 营业执照下方表单 */
/* .yyzzRight {
  width: 80%;
  margin-left: 105px;
} */

/* 营业执照 */
.yyzzDiv {
  width: 500px;
  height: 200px;
  margin-bottom: 20px;
  position: relative;
}
.yyzzAvatarImg {
  width: 360px;
  height: 200px;
  position: absolute;
  top: 0;
  left: 105px;
  border-radius: 5px;
  border-top-left-radius: 0;
  border: 1px solid #e5e5e5;
}
.yyzzUploader {
  width: 360px;
  height: 200px;
  line-height: 200px;
  position: absolute;
  top: 0;
  left: 105px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  border-top-left-radius: 0;
}
/* 营业执照 - 说明 */
.yyzzSM {
  width: 360px;
  height: 30px;
  line-height: 30px;
  background: #333;
  border: 1px solid #333;
  position: absolute;
  bottom: -15px;
  left: 105px;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  opacity: 0.6;
}
/* 营业执照 - 删除icon */
.yyzzDel {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: 25px;
  top: -5px;
  cursor: pointer;
}

/* 人像 & 国徽 */
.rxgh {
  width: 600px;
  height: 200px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
}
.rxghDiv {
  width: 280px;
  height: 200px;
  position: relative;
}
.rxghAvatarImg {
  width: 280px;
  height: 200px;
  border-radius: 5px;
  border: 1px solid #e5e5e5;
}
.rxghUploader {
  width: 280px;
  height: 200px;
  line-height: 200px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
}
/* 人像 & 国徽 - 说明 */
.rxghSM {
  width: 280px;
  height: 30px;
  line-height: 30px;
  background: #333;
  border: 1px solid #333;
  position: absolute;
  bottom: -15px;
  left: 0;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  opacity: 0.6;
}
/* 删除-icon */
.chahao {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: #666;
  position: absolute;
  right: -8px;
  top: -5px;
  cursor: pointer;
}
/* 查看大图 */
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgDialog>img {
  width:auto;
  height:auto;
  max-width:100%;
  max-height:100%;
  border-radius: 3px;
}

/* 开户银行 */
.dropdown-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.radio-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  height: 200px;
  overflow: scroll;
}
.radioBtn {
  margin: 10px 0;
}
/* 搜索 */
.searchKhyh {
  width: 96%;
  margin: 0 0 15px 2%;
}
/* 常用银行 */
.rmyhQuick {
  height: 36px;
  line-height: 36px;
  margin-bottom: 10px;
}
.rmyhClass {
  background: #f2f3f8;
  border-radius: 32px;
  color: #3171f6;
  margin-left: 15px;
  padding: 6px 10px;
  cursor: pointer;
}
.spanTitle {
  margin-left: 15px;
  padding: 6px 10px;
  cursor: pointer;
}

/* 打款信息 */
.dkClass {
  width: 90%;
  margin-bottom: 10px;
}
.dkClass>li {
  line-height: 32px;
}
.dkColor {
  color: #3171f6;
}
/* 业务办理授权函 */
.sqhPic {
  width: 268px;
  height: 100px;
  margin-bottom: 20px;
  position: relative;
}
.sqhImg {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 160px;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  /* border-top-left-radius: 0; */
}
.sqhIcon {
  width: 100px;
  height: 100px;
  line-height: 100px;
  position: absolute;
  top: 0;
  left: 160px;
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  /* border-top-left-radius: 0; */
}
/* 业务办理授权函 - 删除icon */
.sqhDel {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  /* line-height: 25px; */
  color: #666;
  position: absolute;
  right: 0;
  top: -5px;
  cursor: pointer;
}
.ywblsqh {
  width: 80%;
  line-height: 22px;
  padding-left: 0;
}
</style>


// WEBPACK FOOTER //
// collectionSettings.vue?79139f8e